
import { createTheme } from '@mui/material/styles';
/**
 * Theme for Material UI
 */
const theme = createTheme({
  shape: {
    borderRadius: 0
  },
  transitions: {
    duration: {
      enteringScreen: 1000, // Used when a screen enters
    }
  },
})

export default theme